import styles from './TextCheckingIcon.module.scss'

export function TextCheckingIcon({ accessibilityLabel }: { readonly accessibilityLabel: string }) {
  const isDecorative = accessibilityLabel === ''
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={accessibilityLabel}
      aria-hidden={isDecorative}
      data-icon="TextChecking"
    >
      <path
        d="M1 9.00027C1 4.5814 4.58107 1 9.0004 1C13.4197 1 17 4.5814 17 9.00027C17 12.8662 14.2591 16.0913 10.6138 16.8378C10.0929 16.9446 9.55335 17 9.00281 17H1V9.00027Z"
        fill="#027E6F"
      />
      <circle className={styles.dot1} cx="6" cy="9" r="1" fill="white" />
      <circle className={styles.dot2} cx="9" cy="9" r="1" fill="white" />
      <circle className={styles.dot3} cx="12" cy="9" r="1" fill="white" />
    </svg>
  )
}
